import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { NoticeReceipentType, redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader
} from "../../../../../../../_metronic/_partials/controls";
import { StudentsFilter } from "./receipent-students-filter/StudentsFilter";
import { StudentsTable } from "./receipent-students-table/StudentsTable";
import { useStudentsUIContext } from "./StudentsUIContext";

export function StudentsCard({
  receipentType
}) {
  // Students Card UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      queryParams: studentsUIContext.queryParams
    };
  }, [studentsUIContext]);

  // Getting curret state of Students from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );  
  const { isSuccess, type } = currentState;

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const receipent = receipentType === NoticeReceipentType.Student ? "Öğrenci" : receipentType === NoticeReceipentType.AdvisorStudent ? "Danışman Öğrenci" : "";
  
  return (
    <Card>
      <CardHeader title={"Gönderilen " + receipent + " Listesi"} />
      <CardBody>
        <StudentsFilter />
        <StudentsTable />
      </CardBody>
    </Card>
  );
}